import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center gap-4" }
const _hoisted_2 = { class: "grid lg:grid-cols-2 gap-12 place-items-center overflow-hidden" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]

import BaseCard from '@/features/global/BaseCard.vue';
import EPShrubs from '@/assets/Projects/EagleProjectPhotos/EPShrubs.png';
import EPBenches from '@/assets/Projects/EagleProjectPhotos/EPBenches.png';
import { useImageViewer } from '@/features/composables/useImageViewer';


export default /*@__PURE__*/_defineComponent({
  __name: 'EagleProject',
  setup(__props) {

const { openImageMenu } = useImageViewer();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseCard, {
    title: 'Eagle Project for LCA',
    highlightLastWord: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "w-full grid lg:grid-cols-2 lg:gap-20" }, [
          _createElementVNode("h5", { class: "lg:justify-self-end lg:pr-6 font-medium" }, "Project Manager & Leader"),
          _createElementVNode("h5", { class: "lg:justify-self-start lg:pl-6 font-medium" }, "April 2022 - August 2022")
        ], -1)),
        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-center items-center pl-4 pr-4" }, [
          _createTextVNode(" Service revamp of gym/CYO entrances to Lakewood Catholic Academy"),
          _createElementVNode("br"),
          _createTextVNode(" All new shrubs, perennials, mulch, bench area with gravel, and flowers"),
          _createElementVNode("br"),
          _createTextVNode(" Planned, fundraised, lead, and reported by me"),
          _createElementVNode("br"),
          _createElementVNode("a", {
            href: "https://drive.google.com/drive/folders/1PQ0kxLRNEFaV2E9w1UQO3OjVbdjeVT2S?usp=sharing",
            target: "_blank",
            class: "link-in-text"
          }, "Photos!"),
          _createElementVNode("br")
        ], -1)),
        _createElementVNode("span", _hoisted_2, [
          _createElementVNode("img", {
            class: "w-full h-auto rounded-lg hidden lg:block cursor-pointer",
            src: _unref(EPShrubs),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openImageMenu)(_unref(EPShrubs), 'Eagle Project Shrubs', $event.currentTarget)))
          }, null, 8, _hoisted_3),
          _createElementVNode("img", {
            class: "w-full h-auto rounded-lg cursor-pointer",
            src: _unref(EPBenches),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(openImageMenu)(_unref(EPBenches), 'Eagle Project Benches', $event.currentTarget)))
          }, null, 8, _hoisted_4)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})